.header {
    .line {
        margin-top: 24px;
        border-bottom: solid 1px #C1CBD7;
    }
}